export const SlickCarousels = (function () {
	'use strict'; 

    let $popularSearchWrapper;

	function init() {
        $popularSearchWrapper = $('.shop__popular-searches__wrapper');
		
        if($popularSearchWrapper.length) {
            popularSearch();
        }
	}

	function popularSearch() {
        // Shop Page Popular Search Carousel
        $popularSearchWrapper.slick({
            arrows: true,
            centerMode: true,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        //centerMode: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }
            ]
        });
    }

	return {
		init: init,
	};
})();
